<template>
  <div
    class="vertical-counters"
    :style="`grid-template-columns:${allSubs.length > 1 ? '1fr 1fr' : '1fr'}`"
  >
    <div
      v-for="sub in allSubs"
      :key="sub.public_id"
      class="vertical-counter"
    >
      <TierTag
        class="tag-wrap uppercase w-100"
        style="--title-size: 1rem; --title-weight: 500"
        :paymentInterval="sub.plan.interval"
        :customGame="sub.plan.type.toUpperCase()"
        :customTier="sub.plan.tier"
        :hasIcon="false"
        :isSimple="true"
        :hasInterval="false"
        :hasTier="false"
        :hasGamesTier="false"
      />

      <div
        class="vertical-counter_max anim-fade-in mt-1"
        :style="`height:1.75rem`"
      >
        <div
          class="spent-hands"
          data-tst="plan_counter_count"
        >
          {{ numLocale(getCurrentValue(sub)) }}
          /
          {{ numLocale(getMaxValue(sub)) }}
        </div>
        <div
          class="value"
          :class="{ 'min-value': getCurrentValue(sub) }"
          :style="`width:${(getCurrentValue(sub) / getMaxValue(sub)) * 100}%`"
        ></div>
      </div>

      <div
        class="vertical-counter_date mt-1 text-smallest text-grey truncate csst"
        style="max-width: 14rem"
        @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
      >
        {{ $t('hand_counter.hands_quota_reset_date', { date: getStartDate(sub) }) }}
        <i class="mdi mdi-information-outline"></i>
        <div
          class="csst_content"
          style="position: fixed"
        >
          {{ $t('hand_counter.hands_quota_reset', { date: getStartDate(sub) }) }}
        </div>
      </div>

      <div
        v-if="sub.plan.tier !== 'ELITE' || getCurrentValue(sub) / getMaxValue(sub) === 1"
        class="mt-2 w-100 gw_btn gw_btn-vs1 gw_btn_primary"
        @click="handleUpgrade(sub)"
      >
        {{ $t('btn.get_more_hands') }}
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import tier_mix from '@/mixins/tier_mix'
import TierTag from '@/components/Sub/TierTag'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'VerticalCounter',
  components: {
    TierTag,
  },
  mixins: [format_mix, tier_mix, float_mix],
  props: {
    mini: Boolean,
  },
  methods: {
    handleUpgrade(sub) {
      if (sub.plan.type.toLowerCase() === 'any') {
        this.$router.push({ name: 'Subscription' })
      } else {
        this.$router
          .push({
            name: 'UserAccount',
            query: {
              gm_type: sub.plan.type.toLowerCase(),
              gm_tier: sub.plan.tier.toLowerCase(),
              gm_interval: sub.plan.interval.toLowerCase(),
            },
          })
          .catch(() => {})

        setTimeout(() => {
          this.$store.dispatch('router_set_dialogs', 'update-payment-plan-dialog')
        })
      }
    },
    getMaxValue(sub) {
      return sub.hands_limit || 0
    },
    getCurrentValue(sub) {
      return sub.hands_usage.hands_used || 0
    },
    getStartDate(sub) {
      const isoDate = sub.hands_usage.reset_date
      if (isoDate) {
        return this.formatISODate(isoDate)
      }
      return '#error'
    },
  },
}
</script>

<style lang="scss" scoped>
.vertical-counters {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  align-items: flex-start;
}
.vertical-counter {
  width: 100%;
  position: relative;
  align-items: flex-start !important;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  &_title {
    font-weight: 500;
  }
  &_max {
    flex-shrink: 0;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--clr-black-3);
    .spent-hands {
      position: absolute;
      z-index: 2;
      font-size: 0.8rem;
    }
    .min-value {
      min-width: 2px;
    }
    .value {
      background: var(--clr-primary);
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      will-change: width;
      transition: width 0.8s ease-in-out;
    }
  }
  &_date {
    font-size: 0.8rem;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>
